// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Hq7f","row":"styles_row__2PSAn"};